export enum LoginType {
    UsernamePassword = 1,
    OneTimePassword = 2
}